import { render, staticRenderFns } from "./ClientActionAssignModal.vue?vue&type=template&id=5669f0f9&"
import script from "./ClientActionAssignModal.vue?vue&type=script&lang=js&"
export * from "./ClientActionAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientActionAssignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports